import styled from '@emotion/styled'
import theme from '@utils/theme'

export const StyleMaintainanceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: start;
    row-gap: 10px;
  }
`

export const StyleContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  row-gap: 12px;
  flex: 0.8;
`

export const StyleTitle = styled.p`
  color: ${theme.colors.text};
  font-size: 18px;
  font-weight: 400;
`
export const Stylesubtitle = styled.p`
  color: ${theme.colors.text50};
  font-size: 14px;
  line-height: 1.5;
  margin-top: 0.5rem;
  @media (max-width: 768px) {
    font-size: 12px;
    width: 240px;
  }
`
